export default function Privacy() {
  return (
    <div className="flex min-h-screen flex-col bg-md-bg">
      <header className="sticky top-0 z-50 border-b border-md-sky/60 bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex h-[72px] max-w-[1280px] items-center justify-between px-6 md:px-12">
          <a href="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/100c669628d567e493b0574d25985585/fdd0fbd9bd30abc0ce68dc53ed7f4af7.jpeg"
              alt="Logo Multidroguerías"
              className="h-12 w-12 rounded-lg object-cover"
            />
            <div className="flex flex-col">
              <span className="font-serif text-[18px] font-bold leading-tight text-md-ink">
                Multidroguerías
              </span>
              <span className="text-[11px] font-medium text-md-slate">
                Servicio de domicilio
              </span>
            </div>
          </a>
          <a
            href="/"
            className="flex items-center gap-2 text-[14px] font-semibold text-md-dark transition-colors hover:text-md-blue"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-left-line" />
            </span>
            Volver
          </a>
        </div>
      </header>

      <main className="flex-1">
        <div className="mx-auto max-w-[800px] px-6 py-16 md:px-12 md:py-24">
          <h1 className="mb-10 font-serif text-[28px] font-bold text-md-ink md:text-[36px]">
            Política de privacidad
          </h1>

          <div className="flex flex-col gap-8 text-[15px] leading-[1.7] text-md-slate md:text-[16px]">
            <p>
              <strong className="text-md-ink">MULTIDROGUERIAS</strong>, comunica a sus grupos de interés la Política de Privacidad que ha sido adoptada en cumplimiento del régimen legal vigente contenido en la Ley Estatutaria 1581 de 2012 y 1266 de 2008 en lo pertinente.
            </p>

            <p>
              <strong className="text-md-ink">MULTIDROGUERIAS</strong> trata datos personales de sus grupos de interés en ejecución de su objeto mercantil, esto es, el distribución y suministro de medicamentos, productos intrahospitalarios y productos de consumo masivo, a través de sus establecimientos de comercio, bien sea a través de canales físicos y/o electrónicos.
            </p>

            <p>
              Los datos personales en custodia de <strong className="text-md-ink">MULTIDROGUERIAS</strong> en su condición de responsable y/o encargado según el caso, serán tratados cumpliendo los principios y regulaciones previstas en las leyes colombianas y las buenas prácticas aplicables al régimen de protección de datos personales, en consecuencia serán tratados conforme las siguientes finalidades de carácter general:
            </p>

            <ul className="flex list-disc flex-col gap-3 pl-5">
              <li>Para cumplir con las obligaciones derivadas de los contratos comerciales y demás negocios jurídicos que celebra <strong className="text-md-ink">MULTIDROGUERIAS</strong> en desarrollo de su actividad principal.</li>
              <li>Para el cumplimiento de las obligaciones y/o compromisos derivados de las relaciones, contractuales o no, existentes con sus grupos de interés, tales como contratos de compra-venta, suministro de bienes y servicios entre otros.</li>
              <li>Para el cumplimiento de las obligaciones legales que involucren datos personales de sus grupos de interés, tales como contratos de trabajo, de prestación de servicios, proveedores, entre otros.</li>
              <li>Para la gestión comercial y relacionamiento con sus grupos de interés.</li>
              <li>Para comunicar a sus grupos de interés información sobre sus bienes, servicios, publicaciones, eventos de capacitación, actividades comerciales y publicidad asociada a su actividad empresarial, sea que se realice de manera directa o no.</li>
              <li>Para desplegar hacia sus grupos de interés actividades de responsabilidad social empresarial.</li>
              <li>Para gestionar la seguridad de las personas, bienes y activos de información en custodia de la organización.</li>
            </ul>

            <p>
              En cada proceso empresarial y acorde con los datos personales recolectados y tratamiento a realizar, en el respectivo aviso de privacidad se informarán de forma previa las finalidades particulares, nombre o razón social y datos de contacto del responsable o encargado del tratamiento, si el tratamiento se efectuará por un encargado, tal encargado estará bajo la dirección de <strong className="text-md-ink">MULTIDROGUERIAS</strong>; los derechos que le asisten al titular y los mecanismos dispuestos por <strong className="text-md-ink">MULTIDROGUERIAS</strong> para dar a conocer las Políticas de Privacidad.
            </p>

            <h2 className="font-serif text-[20px] font-semibold text-md-ink">
              Derechos del titular
            </h2>

            <p>
              Cualquier persona que haga parte de uno de los grupos de interés, en su condición de titular o legítimamente autorizado, en relación con tratamiento de sus datos personales tiene derecho a:
            </p>

            <ul className="flex list-disc flex-col gap-3 pl-5">
              <li>Ejercer su derecho de Habeas Data consistente en conocer, actualizar, rectificar su información de carácter personal. También podrá oponerse y cancelar sus datos e información personal en aquellos casos en que proceda.</li>
              <li>Evidenciar la existencia del consentimiento otorgado, salvo que exista autorización legal para el tratamiento o el mismo se realice en el marco de un contrato.</li>
              <li>Ejercer las acciones que la ley reconoce en materia de protección de datos personales y habeas data.</li>
            </ul>

            <h2 className="font-serif text-[20px] font-semibold text-md-ink">
              Ejercicio del Habeas Data
            </h2>

            <p>
              Para el ejercicio del Habeas Data, el titular del dato personal o quien demuestre un legítimo interés conforme lo señalado en la normatividad vigente, podrá hacerlo a través del siguiente correo electrónico <a href="mailto:habeasdata@multidroguerias.com" className="text-md-blue underline">habeasdata@multidroguerias.com</a> o a través de la línea telefónica <a href="tel:+573206789030" className="text-md-blue underline">3206789030</a>. Quien ejerza el habeas data deberá suministrar con precisión los datos de contacto solicitados para efecto de tramitar, atender y responder su solicitud y desplegar las cargas para el ejercicio de sus derechos. Recibida la solicitud de ejercicio de Habeas Data, <strong className="text-md-ink">MULTIDROGUERIAS</strong> dará respuesta en los términos de ley acorde con lo dispuesto en sus normas.
            </p>

            <p>
              Esta política será objeto de desarrollo a través de las normas y procedimientos que se requieran para implementar la privacidad y protección de datos en la operación de la compañía y se publicita frente a terceros a través del portal WEB y demás medios electrónicos.
            </p>

            <h2 className="mt-6 font-serif text-[20px] font-semibold text-md-ink">
              Aviso de privacidad
            </h2>

            <p>
              <strong className="text-md-ink">Aviso de privacidad:</strong>{" "}
              <strong className="text-md-ink">MULTIDROGUERIAS</strong>{" "}
              comunica que el suministro de datos personales a través de este
              portal web implica la autorización del titular para que estos
              sean tratados de manera segura, confidencial y responsable para
              fines de establecer contacto e informar sobre nuestros
              productos, servicios, actividades, ofertas, promociones,
              alianzas, entre otras actividades empresariales, datos personales
              que serán tratados en el marco de las relaciones
              precontractuales, contractuales y post contractuales, aplicando
              lo dispuesto en el régimen de la ley 1581 de 2012 y/o ley 1266 de
              2008, según sea el caso. Esta información será gestionada en una
              infraestructura informática segura por parte{" "}
              <strong className="text-md-ink">MULTIDROGUERIAS</strong> y/o de
              sus encargados.
            </p>

            <p className="mt-3">
              El tratamiento se realizará en cumplimiento de lo dispuesto en la
              política de privacidad la cual puede consultar a través del
              siguiente enlace:
            </p>

            <p className="mt-3">
              Para el ejercicio del Habeas Data, el titular del dato personal o
              quien demuestre un legítimo interés conforme lo señalado en la
              normatividad vigente, podrá hacerlo a través del siguiente
              correo electrónico{" "}
              <a
                href="mailto:habeasdata@multidroguerias.com"
                className="text-md-blue underline"
              >
                habeasdata@multidroguerias.com
              </a>{" "}
              o a través de la línea telefónica{" "}
              <a href="tel:+573206789030" className="text-md-blue underline">
                3206789030
              </a>
              . Quien ejerza el habeas data deberá suministrar con precisión
              los datos de contacto solicitados para efecto de tramitar,
              atender y responder la solicitud y desplegar las cargas para el
              ejercicio de sus derechos. Recibida la solicitud de ejercicio de
              Habeas Data{" "}
              <strong className="text-md-ink">MULTIDROGUERIAS</strong> dará
              respuesta en los términos de ley acorde con lo dispuesto en sus
              normas.
            </p>

            <p className="mt-4 text-[14px] text-md-slate/70">
              Última actualización: mayo de 2026
            </p>
          </div>
        </div>
      </main>

      <footer className="bg-md-ink">
        <div className="mx-auto max-w-[1280px] px-6 py-8 md:px-12">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <p className="text-[13px] text-[#ddd] md:text-[14px]">
              &copy; 2026 Multidroguerías. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6">
              <a href="/politica-de-privacidad/" className="text-[13px] text-[#ddd] underline md:text-[14px]">
                Política de privacidad
              </a>
              <a href="/terminos-y-condiciones/" className="text-[13px] text-[#ddd] underline md:text-[14px]">
                Términos y condiciones
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}